import gsap from "gsap";
import { SplitText } from "gsap/src/SplitText";
import { ScrollTrigger } from "gsap/src/ScrollTrigger";

gsap.registerPlugin(SplitText, ScrollTrigger);


function createParallaxEffect() {
  gsap.utils.toArray('.parallax-container').forEach(container => {

    const img = container.querySelector('img');
  
    // Create a GSAP timeline for the image with a ScrollTrigger
    gsap.timeline({
      scrollTrigger: {
        trigger: container,
        start: "top bottom", // When the top of the container enters the bottom of the viewport
        end: "bottom top", // When the bottom of the container exits the top of the viewport
        scrub: 1 // Smooth out the animation's beginning and end (adjust the number for more/less smoothing)
      }
    })
    .fromTo(img, {
      y: '6%' // Start the image slightly above its normal position
    }, {
      y: '0%', // End with the image slightly below its normal position
      ease: "none" // Keep the movement linear
    });
  });
}

  

  function animateText() {
    let resizeTimer; // Timer identifier for debouncing
  
    const elements = document.querySelectorAll(".animate-text");
  
    // Cleanup function to remove animation wrappers
    function cleanupAnimations() {
      elements.forEach(element => {
        const wrappers = element.querySelectorAll('div');
        wrappers.forEach(wrapper => {
          while (wrapper.firstChild) {
            wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
          }
          wrapper.parentNode.removeChild(wrapper);
        });
      });
    }
  
    // Function containing the core animation logic
    function initializeAnimations() {
      elements.forEach(element => {
        const animationType = element.getAttribute("data-animation-type") || "lines";
        const ease = element.getAttribute("data-ease") || "power4.out";
        const delay = parseFloat(element.getAttribute("data-delay")) || 0.5;
        const duration = parseFloat(element.getAttribute("data-duration")) || 0.5;
        const staggerVal = parseFloat(element.getAttribute("data-stagger")) || 0.1;
        const clipAnimation = element.getAttribute("data-clip-animation") === "true";
  
        if (animationType === "lines" || animationType === "words") {
          const split = new SplitText(element, {
            type: animationType,
            linesClass: "line-child",
            wordsClass: "word-child"
          });
  
          let targets = animationType === "lines" ? split.lines : split.words;
  
          if (clipAnimation) {
            targets.forEach((target, i) => {
              target.style.opacity = 0;
              target.style.transform = 'translateY(100%)';
  
              const wrapper = document.createElement('div');
              wrapper.style.overflow = 'hidden';
              wrapper.style.paddingBottom = '0.1em';
              if (animationType === "words") {
                wrapper.style.display = 'inline-block';
              }
  
              target.parentNode.insertBefore(wrapper, target);
              wrapper.appendChild(target);
  
              let elementDelay = delay + i * staggerVal;
  
              gsap.to(target, {
                duration: duration,
                y: '0%',
                opacity: 1,
                ease: ease,
                delay: elementDelay,
                scrollTrigger: {
                  trigger: element,
                  start: "top bottom-=100",
                  end: "bottom top",
                  toggleActions: "play none none none"
                }
              });
            });
          } else {
            gsap.from(targets, {
              duration: duration,
              yPercent: 100,
              opacity: 0,
              ease: ease,
              delay: delay,
              stagger: staggerVal,
              scrollTrigger: {
                trigger: element,
                start: "top bottom-=100",
                end: "bottom top",
                toggleActions: "play none none none"
              }
            });
          }
        } else {
          gsap.from([element], {
            duration: duration,
            yPercent: 0,
            opacity: 0,
            ease: ease,
            delay: delay,
            stagger: {
              amount: staggerVal
            },
            scrollTrigger: {
              trigger: element,
              start: "top bottom-=100",
              end: "bottom top",
              toggleActions: "play none none none"
            }
          });
        }
      });
    }
  
    // Resize event listener with debouncing
    if (!('ontouchstart' in window) || navigator.maxTouchPoints === 0) {
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            cleanupAnimations(); // Remove existing animations and wrappers
            initializeAnimations(); // Reinitialize animations
          }, 10); // Adjust debounce time as needed
        });
      }
  
    // Initial call to set up animations
    initializeAnimations();
  }


  function animateImageSwipeIn() {
    const containers = gsap.utils.toArray(".swipe-container, .project-image");
  
    containers.forEach((container) => {
      // Ensure the container clips the content
      gsap.set(container, { overflow: 'hidden' });
  
      // Select the image within the container
      const image = container.querySelector("img");
  
      // Initialize the image offscreen to the left and slightly zoomed in
      gsap.set(image, { yPercent: 0, scale: 1, opacity: 1 });
  
      // Animate the image to swipe in from the left and scale down to normal size
      gsap.to(image, {
        yPercent: 0, // Bring the image back to its original horizontal position
        scale: 1.03,   // Scale down to the original size
        duration: 1.3, // Duration of the swipe-in and scale-down animation
        ease: "power2.out", // Smooth easing function for the animation
        scrollTrigger: {
          trigger: container, // The animation triggers when the parent container enters the view
          start: "top 70%", // Start the animation when the top of the container hits 90% of the viewport
          end: "bottom top", // End when the bottom of the container exits the top of the viewport
          toggleActions: "play none none none", // Play the animation once when the container enters the viewport
          markers: false // Enable during development to see the trigger points
        }
      });
    });
  }


export default {
    init: function() {
        animateText();
        createParallaxEffect();
        animateImageSwipeIn();
    }
};
